import { Ref } from "react";

export interface IHumanVerifier {
  reset: () => void;
}

export interface HumanVerifierProps {
  onSuccess: (token: string) => void,
  ref?: Ref<IHumanVerifier>;
}

export const HUMAN_VERIFIER_NON_WEB_SUCCESS = "SUCCESS";
